{
  "invalidSelection": "נבחר {selectedCount, plural, one {תאריך} other {תאריכים}} אינו זמין."
}
